import React from 'react';
import styled from 'styled-components';
import TextInput from 'component/ui/input/TextInput';
import { ArrowUpIcon, ArrowDownIcon } from 'component/ui/icons';

const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-left: 1px solid ${({ theme }) => theme.color.COOL_GRAY_40};
  margin-right: -8px;
  box-sizing: border-box;
  height: 100%;
`;

const StepButton = styled.button`
  border-radius: 0;
  border: none;
  width: 20px;
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  background: transparent;
  outline: none;
  & + & {
    border-top: 0.5px solid ${({ theme }) => theme.color.COOL_GRAY_40};
  }
  &:active {
    background-color: ${({ theme }) => theme.color.COOL_GRAY_50};
  }
`;

const StyledArrowUpIcon = styled(ArrowUpIcon)`
  display: inline-block;
  width: 20px;
  height: 12px;
  cursor: pointer;
  path {
    fill: ${({ theme }) => theme.color.COOL_GRAY_80};
  }
`;
const StyledArrowDownIcon = styled(ArrowDownIcon)`
  display: inline-block;
  width: 20px;
  height: 12px;
  cursor: pointer;
  path {
    fill: ${({ theme }) => theme.color.COOL_GRAY_80};
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: stretch;
`;

function NumberInput(
  {
    min,
    max,
    step,
    disabled,
    onChange,
    value,
    inputStyle,
    wrapperStyle,
    stepButtonStyle,
  },
  ref
) {
  const onClickStepUp = () => {
    if (!onChange) return;

    let stepUpResultValue = Number(value) >= max ? max : value + 1;
    onChange(stepUpResultValue);
  };

  const onClickStepDown = () => {
    if (!onChange) return;

    let stepDownResultValue = Number(value) <= 1 ? min : value - 1;
    onChange(stepDownResultValue);
  };

  return (
    <Wrapper style={wrapperStyle}>
      <TextInput
        ref={ref}
        style={inputStyle}
        disabled={disabled}
        inputType="number"
        min={min}
        max={max}
        step={step}
        value={value}
        adornment={
          !disabled && (
            <StepWrapper>
              <StepButton style={stepButtonStyle} onClick={onClickStepUp}>
                <StyledArrowUpIcon />
              </StepButton>
              <StepButton style={stepButtonStyle} onClick={onClickStepDown}>
                <StyledArrowDownIcon />
              </StepButton>
            </StepWrapper>
          )
        }
        onChange={(text) => {
          onChange && onChange(text);
        }}
      />
    </Wrapper>
  );
}

export default React.forwardRef(NumberInput);
